module.exports = __webpack_public_path__ + "static/media/strutture-campo-calcetto-a5-completo-noleggiocampi.a2c21ef5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/campi/calcetto/slider1/strutture-campo-calcetto-a5-completo-noleggiocampi.jpg
// module id = 641
// module chunks = 0